import api from './api';

/**
 * COSTING.1a — client for the cost-layer drift report + group rebuild.
 * GET  /admin/venue/:venueId/inventory/cost-layer-drift          (ADMIN_ONLY)
 * POST /admin/venue/:venueId/inventory/cost-layer-drift/rebuild  (ADMIN_ONLY)
 */

export interface LayerDriftLayer {
  layerId: string;
  sourceType: string;
  costBasis: string;
  unitCost: number | null;
  remainingQty: number;
  originalQty: number;
  receivedDate: string;
}

export interface LayerDriftGroup {
  inventoryItemId: string;
  itemName: string | null;
  locationId: string;
  locationName: string | null;
  ownershipAccountId: string;
  layerRemaining: number | null;
  balanceQuantity: number | null;
  difference: number;
  kind: 'MISMATCH' | 'ORPHAN_LAYERS' | 'MISSING_LAYERS';
  /** COSTING.1d — group holds one or more provisional (negative) layers. */
  hasProvisionals?: boolean;
  layers: LayerDriftLayer[];
}

export interface LayerDriftReport {
  venueId: string;
  active: boolean;
  generatedAt: string;
  clean: boolean;
  summary: { mismatched: number; orphanLayers: number; missingLayers: number; totalGroupsChecked: number };
  groups: LayerDriftGroup[];
}

export interface RebuildResult {
  deleted: number;
  created: number;
  quantity: number;
  unitCost: number | null;
}

const costLayerDriftService = {
  getLayerDrift: async (venueId: string): Promise<LayerDriftReport> => {
    const response = await api.get(`/admin/venue/${venueId}/inventory/cost-layer-drift`);
    return response.data;
  },
  rebuildGroup: async (
    venueId: string,
    body: { inventoryItemId: string; locationId: string; ownershipAccountId: string },
  ): Promise<RebuildResult> => {
    const response = await api.post(`/admin/venue/${venueId}/inventory/cost-layer-drift/rebuild`, body);
    return response.data;
  },
};

export default costLayerDriftService;
